import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sbd-home',
  templateUrl: './sbd-home.component.html',
  styleUrls: ['./sbd-home.component.scss']
})
export class SBDHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
